'use client'


import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { CreateSampleRequest } from '@/graphqlFx/createContactForm';
import { FormAPI } from '@/components/home/contactForm/FormAPI';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';



export default function SampleRequest(){


  const {executeRecaptcha} = useGoogleReCaptcha();
  const [isLoading, setIsLoading] = useState(false)

  const [triggerApiCall, setTriggerApiCall] = useState(false); // To control when the API call happens

  const [sampleData, setSampleData] = useState({
    status:"",
    firstName:"",
    lastName:"",
    email:"",
    phone:"",
    company:"",
    industry:"",
    address:"",
    city:"",
    country:"",
    state:"",
    message:""
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSampleData({
      ...sampleData,
      [name]: value,
    });
  };




  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);


    if(!executeRecaptcha){
        console.error('executeRecaptcha not yet loaded');
        return;
      }
      
    try{
      const token = await executeRecaptcha("Test_Sample_Form_Submit");
  
      const response = await fetch('/api/recaptcha', {
        method:'POST',
        headers:{
          'Content-Type':'application/json'
        },
        body:JSON.stringify({token})
      })
  
      const data = await response.json();
  
      if(data.success){
        console.log('reCAPTCHA success: ', data.score)
        setSampleData((prevState) => ({
          ...prevState,
          status: "pending",
        }));
        setTriggerApiCall(true);
      }
      else{
        console.log('reCAPTCHA Fail: ', data.score)
        setSampleData((prevState) => ({
          ...prevState,
          status: "spam",
        }));
        setTriggerApiCall(true);
      }
    } catch (error) {
      console.error('Error in Submittion');
    } finally {
      setIsLoading(false);
    }
    


  };

  const SubmitToAPI = async() => {
    try {
      const response = await FormAPI(CreateSampleRequest(),sampleData)
      router.push(`/contact/form/?success=1&firstName=${sampleData.firstName}&lastName=${sampleData.lastName}&email=${sampleData.email}`);
      
    } catch (error) {
      router.push(`/contact/form/?success=0&firstName=${sampleData.firstName}&lastName=${sampleData.lastName}&email=${sampleData.email}`);
    }
  }

    // UseEffect to watch for changes in formData or triggerApiCall
    useEffect(() => {
      if (triggerApiCall) {
        (async () => {
          await SubmitToAPI();
          setTriggerApiCall(false); // Reset the flag to prevent repeated calls
        })();
      }
    }, [triggerApiCall]);
  
  const router = useRouter();



    return (
        <>
        <div className="pt-20 min-h-screen p-6 bg-gray-100 flex items-center justify-center">
  <div className="container max-w-screen-lg mx-auto">
    <div>
      <h2 className="font-bold text-xl text-chimib-600">CHIMIART | Test Sample Request</h2>
      <p className="text-chimia-600 mb-6">Fill in the form to send A Test Sample Request to Our expert Team</p>

      <form  onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-lg p-4 px-4 md:p-10 mb-6">
        <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
          <div className="text-chimia-600">
            <p className="font-medium text-chimib-600 text-lg">Personal Details</p>
            <p>Please fill out all the fields.</p>
          </div>

          <div className="lg:col-span-2">
            <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-6">
              <div className="md:col-span-3">
                <label htmlFor="firstName">First Name</label>
                <input type="text" name="firstName" id="firstName" 
                  className="h-10 border mt-1 rounded px-4 w-full bg-gray-50" 
                  value={sampleData.firstName} onChange={handleInputChange}  
                  placeholder="john" required/>
              </div>

              <div className="md:col-span-3">
                <label htmlFor="lastName">Last Name</label>
                <input type="text" name="lastName" id="lastName" 
                className="h-10 border mt-1 rounded px-4 w-full bg-gray-50" 
                value={sampleData.lastName} onChange={handleInputChange} 
                placeholder="Doe" required/>
              </div>

              <div className="md:col-span-2">
                <label htmlFor="phone">Phone Number</label>
                <input type="text" name="phone" id="phone" 
                className="h-10 border mt-1 rounded px-4 w-full bg-gray-50" 
                value={sampleData.phone} onChange={handleInputChange} 
                placeholder="+20-122-000-111" required/>
              </div>

              <div className="md:col-span-4">
                <label htmlFor="email">Email Address</label>
                <input type="text" name="email" id="email" 
                className="h-10 border mt-1 rounded px-4 w-full bg-gray-50" 
                value={sampleData.email} onChange={handleInputChange} 
                placeholder="email@domain.com" required/>
              </div>

              
      
              

            </div>
          </div>
        </div>

        <div className="w-full h-[1px] bg-chimib-600 my-12"></div>

         {/* company data */}

         <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
          <div className="text-chimia-600">
            <p className="font-medium text-chimib-600 text-lg">Company Details</p>
            <p>Please fill out all the fields.</p>
          </div>

          <div className="lg:col-span-2">
            <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-6">
              <div className="md:col-span-3">
                <label htmlFor="company">Company Name</label>
                <input type="text" name="company" id="company" 
                className="h-10 border mt-1 rounded px-4 w-full bg-gray-50" 
                value={sampleData.company} onChange={handleInputChange} 
                placeholder="company" required/>
              </div>

              <div className="md:col-span-3">
                <label htmlFor="industry">Industry</label>
                <input type="text" name="industry" id="industry" 
                className="h-10 border mt-1 rounded px-4 w-full bg-gray-50" 
                value={sampleData.industry} onChange={handleInputChange}
                placeholder="chemicals" required/>
              </div>

              

              <div className="md:col-span-6">
                <label htmlFor="address">Address / Street</label>
                <input type="text" name="address" id="address" 
                className="h-10 border mt-1 rounded px-4 w-full bg-gray-50" 
                value={sampleData.address} onChange={handleInputChange}
                placeholder="" required/>
              </div>

              <div className="md:col-span-2">
                <label htmlFor="city">City</label>
                <input type="text" name="city" id="city" 
                className="h-10 border mt-1 rounded px-4 w-full bg-gray-50" 
                value={sampleData.city} onChange={handleInputChange} 
                placeholder="" />
              </div>

              <div className="md:col-span-2">
                <label htmlFor="country">Country / region</label>
                <input type="text" name="country" id="country" 
                className="h-10 border mt-1 rounded px-4 w-full bg-gray-50" 
                value={sampleData.country} onChange={handleInputChange}
                placeholder="" />
              
              </div>

              <div className="md:col-span-2">
                <label htmlFor="state">State / province</label>
                <input type="text" name="state" id="state" 
                className="h-10 border mt-1 rounded px-4 w-full bg-gray-50" 
                value={sampleData.state} onChange={handleInputChange}
                placeholder="" />
              
              </div>

            

            </div>
          </div>
        </div>


        <div className="w-[100%] h-[1px] bg-chimib-600 my-12"></div>

        {/* qoute data */}

        <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
          <div className="text-chimia-600">
            <p className="font-medium text-chimib-600 text-lg">Request Details</p>
          </div>

          <div className="lg:col-span-2">
            <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-6">
              <div className="md:col-span-6">
                <label htmlFor="message" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">How can we help you?</label>
                <textarea id="message" name="message" rows="6" 
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                value={sampleData.message} onChange={handleInputChange}
                placeholder="Leave a comment..."
                required></textarea>
              </div>

              <div className="md:col-span-6 text-right">
                <div className="inline-flex items-end">
                  <button 
                  type="submit" 
                  data-te-ripple-init data-te-ripple-color="light"
                  disabled={isLoading}
                  className="mt-4 bg-chimib-600 hover:shadow-red-300 shadow-md text-white font-bold py-2 px-4 rounded"
                
                  >
                  {isLoading? 'Sending Quote Request ...':'Send'}
                  
                  </button>
                  </div>
              </div>

            </div>
          </div>
        </div>

      </form>
    </div>

    
  </div>
</div>
        </>
    )

}